import { CLASS_NAME } from './replaceLazyYoutube'
import './LazyYoutube.scss'

function createIFrame(code: string): HTMLIFrameElement {
  const iframe = document.createElement('iframe')

  iframe.setAttribute('class', `${CLASS_NAME}__ytFrame`)
  iframe.setAttribute('frameborder', '0')
  iframe.setAttribute('allowfullscreen', '')
  iframe.setAttribute('allow', 'autoplay; fullscreen')
  iframe.setAttribute(
    'src',
    `https://www.youtube.com/embed/${code}?rel=0&showinfo=0&autoplay=1`
  )

  return iframe
}

export default function lazyYoutube() {
  document
    .querySelectorAll<HTMLDivElement>(`.${CLASS_NAME}`)
    .forEach(element => {
      const embedCode = element.dataset.embed
      element.addEventListener('click', function onLazyYoutubeClick() {
        this.innerHTML = ''
        // @ts-ignore
        this.appendChild(createIFrame(embedCode))
      })
    })
}
